import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  mixins: [mixx],
  name: 'cuponesLiquidados',
  data() {
    return {
      msg: '-',
      loading: false,
      loading_f: false,
      tbv: null,

      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
      }
    }
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      dom: 'Bfrtip',
      buttons: [],
    });
    $('.box').boxWidget();
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  computed: {
    reporte: function () {
      return (
        "/reportes/lapos/liquidaciones?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta
      );
    }
  },
  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      let fl = 0;
      if (this.filtro_li) {
        fl = 1;
        let column5 = this.tbv.column(5)
        column5.visible(false);
        let column4 = this.tbv.column(4)
        column4.visible(false);
      } else {
        fl = 0;
        let column5 = this.tbv.column(5)
        column5.visible(true);
        let column4 = this.tbv.column(4)
        column4.visible(true);
      }
      this.$http
        .post('/reportes/lapos/liquidaciones', this.f_c)
        .then(response => {
          if (response.data.status == 1) {
            for (let i = 0; i < response.data.data.length; i++) {
              for (let a = 2; a < 31; a++) {
                response.data.data[i][a] = this.num_to_many(response.data.data[i][a]);
              }
              this.tbv.row.add(response.data.data[i]);
            }
          }
          this.tbv.draw();
          this.loading = false;
        });
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/liqLapos/index.js